import React from "react";
import TurnrDropdownSelect from "~/components/input/TurnrDropdownSelect.jsx";
import { InputGridWrapper, SettingsContainerWrapper } from "./settingComponents";
import TurnrSupportEmail from "~/components/links/TurnrSupportEmail.jsx";
import { getSelectableFonts } from "~/cores/appCore";
import { getAddFontTooltipInfo } from "./FontSettings";

export default function ButtonDesignSettings(props) {
    const { iFrameData, appProps } = props;
    const selectableFonts = getSelectableFonts(appProps, {
        fonts: iFrameData?.fonts,
    });
    return (
        <SettingsContainerWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    label="Button variant"
                    tooltip="Change the overall style of your buttons"
                    fullWidth={true}
                    {...props.buttonVariant}
                    onChange={props.setButtonVariant}
                    options={iFrameData?.buttonVariantOptions || []}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    label="Button edges"
                    tooltip="Change roundness of buttons"
                    fullWidth={true}
                    {...props.buttonType}
                    onChange={props.setButtonType}
                    options={iFrameData?.buttonTypeOptions || []}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    label="Button effects"
                    tooltip="Select how you want the buttons to behave when clicking/hovering"
                    fullWidth={true}
                    {...props.buttonEffects}
                    onChange={props.setButtonEffects}
                    options={iFrameData?.buttonEffectOptions || []}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    tooltip={getAddFontTooltipInfo()}
                    selectNoneComponent={"None"}
                    placeholder={"Same as general font"}
                    label="Button font"
                    fullWidth={true}
                    {...props.buttonFont}
                    onChange={props.setButtonFont}
                    options={selectableFonts.map((font) => font?.id || font)}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    label="Button text"
                    tooltip="Simply changes how the texts within the button should behave/look"
                    fullWidth={true}
                    {...props.buttonTextType}
                    onChange={props.setButtonTextType}
                    options={iFrameData?.buttonTextOptions || []}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    label="Button text thickness"
                    tooltip={
                        <div>
                            Let us know if you want a different thickness by contacting us at <TurnrSupportEmail />
                        </div>
                    }
                    fullWidth={true}
                    {...props.buttonThickness}
                    onChange={props.setButtonThickness}
                    options={iFrameData?.buttonThicknessOptions || []}
                />
            </InputGridWrapper>
        </SettingsContainerWrapper>
    );
}
